import Icon from '@mdi/react';
import { mdiMapMarkerRadius, mdiAccountOutline, mdiHumanHandsup, mdiDanceBallroom } from '@mdi/js';
import { Container, Row, Col } from 'react-bootstrap';
import './style.css';
import clsx from 'clsx';

interface Props extends React.PropsWithChildren {
    subAcont: Object;
    data: Object;
    user?: Object;
}

const CalendarEvent: React.FC<Props> = ({ subAcont ,data, user }) => {
    let userName = user.firstName + ' ' + user.lastName;
    subAcont.forEach((sub)=>{
        if(sub.usersID == data.usersID){
           
            userName = sub.firstName + " " + sub.lastName
        } ;
    })
    
   
    return (
        <Container className="event__card">
            <Row className="row__card">
                <Col>
                    <span style={{ color: '#CC0033' }}>
                        {data.eventDate +
                            ' ' +
                            data.timeFrom.slice(0, 5) +
                            ' - ' +
                            data.timeTo.slice(0, 5)}
                    </span>
                </Col>
                <Col>
                    <Icon path={mdiAccountOutline} size={1} color="#CC0033" />
                    {userName}
                </Col>
            </Row>
            <Row className="row__card">
                <Col>
                    <Icon path={mdiDanceBallroom} size={1} color="#CC0033" />
                    {data.courseHeadingName}
                </Col>
                <Col>
                    <Icon path={mdiHumanHandsup} size={1} color="#CC0033" />
                    {data.instructors}
                </Col>
            </Row>
            <Row className="row__card">
                <Col>
                    <Icon path={mdiMapMarkerRadius} size={1} color="#CC0033" />
                    {data.localizationName}
                </Col>
                <Col>
                    <b
                        className={clsx({
                            'status__0-4': data.sheduleItemTypeDVID <= 4,
                            'status__5-8':
                                data.sheduleItemTypeDVID >= 5 && data.sheduleItemTypeDVID <= 8,
                            'status__9-9': data.sheduleItemTypeDVID >= 9,
                        })}
                    >
                        {data.sheduleItemTypeName}
                    </b>
                </Col>
            </Row>
        </Container>
    );
};

export default CalendarEvent;
